import Axios from '../utils/Axios';
import AsyncLocalStorage from '../utils/AsyncLocalStorage';
import { SelectType } from '../components/DropdownSelect';

export interface CurrentStoreContext {
  currentStore: SelectType;
}

export type hotelTitleLangType = {
  title_en: string | null;
  title_ch: string | null;
  title_ja: string | null;
  title_th: string | null;
  title_es: string | null;
  title_fr: string | null;
  title_ru: string | null;
  title_de: string | null;
};

export type hotelContentLangType = {
  content_en: string | null;
  content_ch: string | null;
  content_ja: string | null;
  content_th: string | null;
  content_es: string | null;
  content_fr: string | null;
  content_ru: string | null;
  content_de: string | null;
};

export type StoreType = {
  address1: string;
  address2: string;
  city: string | null;
  description: string;
  description_extra: string;
  description_holiday: string;
  description_noti: string;
  id_order: number;
  is_hidden_on_map: number;
  is_mega_store: number;
  is_test_shop: number;
  lat: string;
  lng: string;
  noti_arrival_distance: number;
  noti_nearby_distance: number;
  order_time: number;
  parking_image: string;
  parking_pan: string;
  parking_tilt: string;
  parking_time: number;
  parking_zoom: number;
  pause: number;
  phone_number: string;
  pickup_address: string | null;
  pickup_type: number;
  postcode: any;
  province: any;
  review_count: number;
  status: number;
  store_code: string;
  store_id: number;
  store_name: string;
  store_name_en: string;
  store_type: number;
};

export type StoreDetailType = {
  seq: number;
  store_description: string;
  store_image: StoreImageType[];
};
export type StoreImageType = {
  store_media_id: number;
  url_path: string;
};

export type DeliveryType = {
  store_id?: number;
  limit_order_price: number;
  max_delivery_distance: string;
  base_delivery_price: number;
  base_delivery_distance: string;
  surcharge_delivery_distance: number;
  surcharge_delivery_price: number;
  is_self_delivery: number;
  delivery_call_type: number;
  delivery_estimated_time: number;
  delivery_prepare_time: number;
};

export type DeviceSummaryType = {
  abnormal_count: number;
  abnormal_device: DeviceType[];
  normal_count: number;
  total_count: number;
};
export type DeviceType = {
  user_token_id: number;
  area_number: number;
  number: number;
  device_is_charging: number;
  device_battery: number;
  device_app_state: string;
  device_volume: number;
  device_issue: string;
  device_updated_at: string;
  loggedin_at: string;
  loggedout_at: string;
};

export type HotelIntroType = hotelTitleLangType & {
  card_id?: number;
  title: string | null;
  card_id_order?: number;
  card_type?: number;
  url: string | null;
  resize_path_l?: string | null;
  resize_path_m?: string | null;
  resize_path_s?: string | null;
  card_content: HotelIntroCardType[];
};

export type HotelIntroCardType = hotelContentLangType & {
  content_type?: number;
  url: string | null;
  resize_path_l?: string | null;
  resize_path_m?: string | null;
  resize_path_s?: string | null;
  content: string | null;
  content_id_order?: number;
};

export type ConciergeType = {
  concierge_list_id: number;
  concierge_name: string;
  file_url: string;
  use_yn: number;
};

export type StaffType = {
  created_at: string;
  employee_id: number;
  end_time: string;
  name: string;
  overnight: number;
  phone_number: string;
  schedule_type: number;
  start_time: string;
  status: number;
  store_id: number;
  updated_at: string | null;
  work_days: string;
  is_push_noti: number;
};

const StoreController = {
  signupHotel: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/auth/knock/hotel/signUp';

      const response: any = await Axios.post(sUrl, oParams);
      return response.data;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 회원가입 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 매장정보
  getStore: async (store_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${store_id}/getStore`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  editStore: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editStore';
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 배달정보
  getDeliveryInfo: async (store_id: number) => {
    try {
      let sUrl =
        process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/delivery/${store_id}/getDeliveryInfo`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setDeliveryInfo: async (storeId: number, deliveryManage: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delivery/setDeliveryInfo';
      const oParams = {
        store_id: storeId,
        delivery_manage: deliveryManage,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 영업시간
  getBusinessTime: async (store_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${store_id}/getBusinessTime`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[영업시간 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setBusinessTime: async (store_id: number, work_time: any, break_time: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setBusinessTime';
      const oParams = {
        store_id: store_id,
        work_time: work_time,
        break_time: break_time,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[영업시간 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 사장님정보
  getMerchant: async (store_id: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + `/store/${store_id}/getMerchant`;
      const response: any = await Axios.get(sUrl);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[사장님정보 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setMerchant: async (store_id: number, merchant: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setMerchant';
      const oParams = {
        store_id: store_id,
        merchant: merchant,
      };
      const response: any = await Axios.post(sUrl, oParams);
      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[사장님정보 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 매장 휴무 관리
  getHoliday: async (iStoreId: number) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/' + iStoreId + '/getHoliday';
      const response: any = await Axios.get(sUrl);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장휴무 호출 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setHoliday: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setHoliday';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[매장휴무 저장 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 기기상태현황
  getDeviceSummary: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getDeviceSummary';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getDeviceSummary 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 불러오기
  getHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 특정 호텔 소개 불러오기
  getHotelIntroCard: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getHotelIntroCard';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[특정 호텔 소개 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 순서 변경하기
  editHotelIntroIdOrder: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editHotelIntroIdOrder';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 순서 변경하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 추가하기
  setHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 추가하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 수정하기
  editHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/editHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 수정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 호텔 소개 삭제하기
  delHotelIntro: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delHotelIntro';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[호텔 소개 삭제하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },

  // 컨시어지 불러오기
  getConciergeList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getConciergeList';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[컨시어지 불러오기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 컨시어지 설정하기
  setConciergeList: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setConciergeList';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[컨시어지 설정하기 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  // 직원관리
  getEmployee: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/getEmployee';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[getEmployee 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  setEmployee: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/setEmployee';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[setEmployee 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  delEmployee: async (oParams: any) => {
    try {
      let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delEmployee';
      const response: any = await Axios.post(sUrl, oParams);

      return response;
    } catch (err) {
      let oErr: any = err;
      return {
        ok: false,
        msg: '[delEmployee 오류]' + oErr.toString(),
        data: undefined,
      };
    }
  },
  //   // 호텔 소개 삭제하기
  //   delHotelIntro: async (oParams: any) => {
  //     try {
  //       let sUrl = process.env.REACT_APP_API_KNOCKKNOCK_URL + '/store/delHotelIntro';
  //       const response: any = await Axios.post(sUrl, oParams);

  //       return response;
  //     } catch (err) {
  //       let oErr: any = err;
  //       return {
  //         ok: false,
  //         msg: '[호텔 소개 삭제하기 오류]' + oErr.toString(),
  //         data: undefined,
  //       };
  //     }
  //   },
};

export default StoreController;
